<template>
  <div style="position: relative; height: 100%; width: 100%;">
    <LineChart :data="chartData" :options="enhancedOptions" />
  </div>
</template>

<script>
import { Line as LineChart } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
} from 'chart.js'

ChartJS.register(
  Title, Tooltip, Legend,
  LineElement, PointElement,
  CategoryScale, LinearScale,
  Filler
)

export default {
  name: 'SimpleLineChart',
  components: { LineChart },
  props: {
    chartData: Object,
    chartOptions: Object
  },
  computed: {
    enhancedOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              boxWidth: 12,
              padding: 16,
              font: { size: 11 }
            }
          },
          tooltip: {
            callbacks: {
              // Skryje NaN hodnoty z tooltipu
              label: (context) => {
                if (isNaN(context.parsed.y)) return null;
                return `${context.dataset.label}: ${context.parsed.y} kWh`;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: 'kWh' }
          }
        },
        // Dôležité: skryje NaN body (medzery medzi predmetmi)
        spanGaps: false,
        // Merge s externými options
        ...(this.chartOptions || {})
      }
    }
  }
}
</script>
